import * as React from "react";
// @ts-ignore
import DOMPurify from "dompurify";

export class MessageHtmlText extends React.Component<any> {
  render() {
      const {text} = this.props;

      const cleanHtml = DOMPurify.sanitize(text, {
          ALLOWED_TAGS: ["b", "i", "em", "strong", "a", "p", "ul", "ol", "li", "br"],
          ALLOWED_ATTR: ["href", "title", "target", "rel"],
          FORBID_ATTR: ["onclick", "onerror", "onload"],
          FORBID_TAGS: ["script", "style"]
      });

      return <div dangerouslySetInnerHTML={{__html: cleanHtml}}/>;
  }
}
